const selectedShape = 'Rectangle';
const allowed_corner_shapes = new Array('Square', 'Rectangle');
var base_price = 0;
var polish_multiplier = 0.35;
var polishing_price = 0;
var initial_amount = 0;
let final_amount = 0; // Product price per unit
let quantity_selected = 1;
let surface_area = 0;
const current_url = window.location.href;
const add_min_price = 7.57;
const settings = {"color_text":"#3a3a3a","color_body_text":"#333232","color_sale_text":"#EA0606","color_button":"#3a3a3a","color_button_text":"#ffffff","color_small_button_text_border":"#3a3a3a","color_text_field_text":"#000000","color_text_field_border":"#cccccc","color_text_field":"#ffffff","color_image_overlay_text":"#ffffff","color_image_overlay":"#685858","image_overlay_opacity":40,"color_borders":"#ebebeb","color_body_bg":"#ffffff","type_header_font":{"error":"json not allowed for this object"},"type_header_base_size":26,"type_base_font":{"error":"json not allowed for this object"},"type_base_size":15,"predictive_search_enabled":true,"predictive_search_show_vendor":true,"predictive_search_show_price":true,"share_facebook":true,"share_twitter":true,"share_pinterest":true,"social_twitter_link":"","social_facebook_link":"https:\/\/www.facebook.com\/royaltymirror","social_pinterest_link":"#","social_instagram_link":"https:\/\/www.instagram.com\/royaltymirror\/","social_tumblr_link":"","social_snapchat_link":"","social_youtube_link":"https:\/\/www.youtube.com\/@royaltymirror2460","social_vimeo_link":"","favicon":"\/\/cdn.shopify.com\/s\/files\/1\/0507\/2597\/8291\/files\/favicon-32x32.png?v=1787130233","enable_ajax":false,"business_address":"1688 Meridian Ave, Suit 700\nMiami Beach, FL 33139","contact_info_email":"support@royaltymirror.com","contact_info_phone":"\u003ca href=\"tel:8005826775\"\u003e(800) 582-6775\u003c\/a\u003e","insulated_glass_multiplier":"0.22","multiplier_except_clear_glass":"0.25","argon_gas_multiplier":"0.024","insulated_glass_min_price":"181.81","insulated_glass_price_above_1000":"0","insulated_glass_price_above_1200":"50","insulated_glass_price_above_1500":"80","insulated_glass_price_above_2000":"500","insulated_glass_price_above_2500":"700","insulated_glass_price_above_3000":"800","insulated_glass_price_above_3500":"950","insulated_glass_price_above_4000":"1300","insulated_glass_price_above_4500":"1500","insulated_glass_price_above_5000":"1000","insulated_glass_price_above_10000":"1000","ultra_clear_glass_price":"60","gray_glass_price":"30","tint_bronze_glass_price":"30","frosted_glass_price":"50","black_glass_price":"50","custom_cut_glass_add_min_price":"7.57","custom_cut_glass_price_above_1000":"0","custom_cut_glass_price_above_1200":"90","custom_cut_glass_price_above_1500":"150","custom_cut_glass_price_above_2000":"500","custom_cut_glass_price_above_2500":"600","custom_cut_glass_price_above_3000":"700","custom_cut_glass_price_above_3500":"1200","custom_cut_glass_price_above_4000":"1800","custom_cut_glass_price_above_4500":"2000","custom_cut_glass_price_above_5000":"2500","custom_cut_glass_price_above_10000":"2700","custom_cut_glass_thickness_1_8":"0.168","custom_cut_glass_thickness_3_8":"0.230","custom_cut_glass_thickness_1_2":"0.250","custom_cut_glass_thickness_5_8":"0.700","mirror_multiplier":"0.20","mirror_polish_multiplier":"0.35","mirror_min_price":"25.46","mirror_price_above_1000":"0","mirror_price_above_1200":"70","mirror_price_above_1500":"100","mirror_price_above_2000":"500","mirror_price_above_2500":"705","mirror_price_above_3000":"1000","mirror_price_above_3500":"2000","mirror_price_above_4000":"2000","mirror_price_above_4500":"2100","mirror_price_above_5000":"2100","mirror_price_above_10000":"2100","mirror_beveled_polished_edge_disabled":false,"beveled_edge_disabled":false,"beveled_polished_edge_disabled":false,"seamed_edge_disabled":false,"pencil_polished_edge_disabled":true,"hs_6in_most_popular_price":"0","hs_8in_most_popular_price":"36.00","hs_6in_square_handle_price":"25.00","hs_8in_square_handle_price":"35.00","hs_6in_ladder_handle_price":"55.00","hs_8in_ladder_handle_price":"75.00","hs_knob_handle_price":"40.00","hs_towel_bar_price":"75.00","hs_pull_handle_price":"75.00","matte_black_hardware_price":"170","brushed_nickel_hardware_price":"150","oil_rubbed_bronze_hardware_price":"200","polished_brass_hardware_price":"170","polished_chrome_hardware_price":"150","polished_nickel_hardware_price":"170","satin_brass_hardware_price":"170","shower_door_thickness_3_8":"0.30","shower_door_thickness_1_2":"0.35","glass_table_top_delivery_text":"7-10 Business Days","mirrors_delivery_text":"7-10 Business Days","replacement_glass_delivery_text":"7-10 Business Days","glass_shelves_delivery_text":"7-10 Business Days","laminated_glass_delivery_text":"7-10 Business Days","tempered_glass_delivery_text":"7-10 Business Days","insulated_glass_delivery_text":"7-10 Business Days","shower_doors_delivery_text":"7-15 Business Days","shop_pay_enabled":false,"shop_pay_text":"Pay in full or in 4 interest-free installments of {amount}","order_summary_additional_information":"Safe Delivery Guaranteed","order_summary_additional_information_2":"Order Now \u0026 Secure Your Production Spot!","custom_cut_glass_thickness_3_4":"0.700","mirror_price_above_60":"100","mirror_flat_polished_edge_disabled":false,"checkout_logo_image":"shopify:\/\/shop_images\/Newlogo-dark.png","checkout_accent_color":"#000000","checkout_button_color":"#ffd814","checkout_layout":"onepage","insulated_glass_additional_price":"500","customer_layout":"customer_area"};
const glassHoleEnabled = false;

/**** GLASS TYPE PRICE ADJUSMENT ****/
// These constants define the percentage increase in price for colored glass options
// compared to the base price of clear glass. For example, if the clear glass price is $100 
// and the gray glass price increase is 50%, the final price for gray glass will be $150.
const ultra_clear_glass_price = 60
const gray_glass_price = 30;
const tint_bronze_glass_price = 30;
const frosted_glass_price = 50;
const black_glass_price = 50;

function calculate_price() {
  function calculate_base_price() {
    const [first_val, second_val, third_val, fourth_val] = get_selected_dimensions_values();
    return ( parseFloat(first_val) + parseFloat(third_val) ) * 2;
  }

  function calculate_thickness_price() {
    const thickness = $('input[name=select_thickness]:checked').val();
    const total_area = $('.total_inch_space').val();
    return get_thickness_price(total_area, thickness);
  }

  function get_glass_strength_price() {
    return 20;
  }

  function calculate_edging_price(base_price) {
    const title = $('input[name=select_edging]:checked').val();
    if( title == 'Flat Polished Edge' || title === 'Seamed Edge' ) return 0;
    return base_price * polish_multiplier;
  }

  function get_corner_price() {
    return parseFloat($('input[name=corner_finish]:checked').attr('data-type'));
  }

  function get_glass_type_price(total_amount) {
    const selected_glass_type = $('input[name=glass_types]:checked').val(); 

    const defaultPercentageIncrease = 50;
    const glassType = (selected_glass_type || "").toLowerCase();

    // Define the percentage increases for each glass type
    const glassPriceIncreases = {
        "clear glass": 0,
        "ultra clear": ultra_clear_glass_price,
        "gray glass": gray_glass_price,
        "tint bronze glass": tint_bronze_glass_price,
        "frosted (etch) glass": frosted_glass_price,
        "black glass": black_glass_price,
    };

    // Fetch the percentage increase; default to 50 for unrecognized glass types
    const percentage_increase = glassPriceIncreases[glassType] ?? defaultPercentageIncrease;

    if(percentage_increase === 0) {
      return 0;
    }

   // alert('Total' + total_amount.toString());
    //alert('Percentage Increase'+  percentage_increase.toString());

    return total_amount * (percentage_increase / 100);
  }

  function get_additional_price() {
    /**** Return if current page is laminated glass  ****/
    if (current_url.includes("laminated-glass")) {
      return 0;
    }
  
    let totalAdditionalPrice = 0;
  
    const l = $('.dim_length').val();
    const w = $('.dim_width').val();
    const selected_area = parseFloat(l * w);
  
    // Length/Width based additional price
    const extraLengthPrice = getAdditionalPrice('custom_cut_glass', selected_area, settings);

    return extraLengthPrice;
  }

  const base_price = calculate_base_price();
  const smallest_thickness_price = get_thickness_price($('.total_inch_space').val(), '1/4');
  const thickness_price = calculate_thickness_price();
  const glass_strength_price = get_glass_strength_price();

  const edging_price = calculate_edging_price(base_price);
  const corner_price = get_corner_price();
  const recut_protection_cost = getGlassRecutProtectionCost();
  const additional_price = get_additional_price();
  console.log('Smallest thickness Cost', smallest_thickness_price); 
  console.log('For glass type price', smallest_thickness_price + glass_strength_price + additional_price); 
  const glass_type_price = get_glass_type_price(smallest_thickness_price + glass_strength_price + additional_price);
  const total_amount = thickness_price + glass_strength_price + edging_price + corner_price + recut_protection_cost + additional_price;

  console.log('Thickness price: ', thickness_price);
  console.log('Glass Strength Price: ', glass_strength_price);
  console.log('Glass Type Price:', glass_type_price);
  console.log('Edging Price:', edging_price);
  console.log('Corner Price:', corner_price);
  console.log('Recut Protection Price:', recut_protection_cost);
  console.log('Additional Price:', additional_price);
  console.log("Pre final: ", total_amount)

  const finalAmount = (total_amount + glass_type_price).toFixed(2);
  console.log('Final Amount:', finalAmount);

  return finalAmount;
}

function update_base_price(v1, v2){
    base_price = ( parseFloat(v1) + parseFloat(v2) ) * 2;
}

function update_polishing_price() {
    var title = $('input[name=select_edging]:checked').val();
    if(title == 'Flat Polished Edge') {
        polishing_price = 0;
    }else{
        polishing_price = base_price * polish_multiplier;
    }
    console.log(polishing_price)
}

function get_initial_amount() {
    return initial_amount;
}

function update_initial_amount() {
    /**** Return if current page is laminated glass  ****/
    if(current_url.includes("laminated-glass")) {
        return;
    }

    const l = $('.dim_length').val();
    const w = $('.dim_width').val();
    const selected_area = parseFloat(l * w);
    initial_amount = getAdditionalPrice('custom_cut_glass', selected_area, settings);
    console.log('Area:', selected_area);
    console.log('Additional Cost:', initial_amount);
}

const get_thickness_multiplier = (thickness) => {
    if(thickness == "1/8" || thickness == "5/32" || thickness == "3/16" || thickness == "1/4") {
        return 0.168;
    }
    else if(thickness == "3/8"){
        return 0.230;
    }
    else if(thickness == "1/2"){
        return 0.250;
    }
    else if(thickness == "5/8"){
        return 0.700;
    }
    return 1;
} 

const get_thickness_price = (total_area, thickness) => {
    const multiplier = get_thickness_multiplier(thickness);
    const min_price = total_area <= 400 ? add_min_price : 0;

    let thickness_price = parseFloat((total_area * multiplier) + min_price);
    console.log(`Total area: ${total_area} and multiplier is ${multiplier}`)

    thickness_price += (thickness_price * 10) / 100;

    return thickness_price;
}

function update_thickness_price() {
    var thickness = $('input[name=select_thickness]:checked').val();
    var total_area = $('.total_inch_space').val();

    const thickness_price = get_thickness_price(total_area, thickness);
    $('.step1').val(thickness_price);

    // Update DOM
    calculate_final_amount();
    update_final_price_to_dom();
}

const calculate_final_amount = () => {
    // let total = get_initial_amount();

    // $('.counter_value').each(function() {
    //     total += parseFloat($(this).val());
    // });

    // const recutProtectionCost = getGlassRecutProtectionCost();
    // total += recutProtectionCost;

    // final_amount = total;

    final_amount = calculate_price();
}

const update_order_summary = () => {
    calculate_final_amount();
    update_final_price_to_dom();

    const amount_payable = `$ ${(final_amount * quantity_selected).toFixed(2)}`;
    $('.total_cart').find('strong').text(amount_payable);

    installment_amount = final_amount / 4;
    $('#installment_amount').text('$ ' + installment_amount.toFixed(2));

    if( final_amount > 3000 ){
        $('#installment_li').hide();
    } else {
        $('#installment_li').show();
    }
}

const update_final_price_to_dom = () => {
    const formatted_price = `$ ${final_amount}`;

    $('.total_price').val(final_amount);
    // $('.price__ok').find('p').find('span').text(formatted_price);

    $('.price__ok td:eq(1)').text(formatted_price);
    $('.price_for_mobile strong').text(formatted_price);
}

// Function to show input fields
function showFields(...fields) {
    fields.forEach(field => $(field).show());
}

// Function to hide input fields
function hideFields(...fields) {
    fields.forEach(field => $(field).hide());
}

const calulate_item_surface_area = (width, height, diameter) => {
    if(diameter) {
      surface_area = 0.7854 * diameter * diameter;
    } else {
      surface_area = width * height;
    }
    console.log(`Surface area: ${surface_area}`);
}

const get_weight_thickness_multiplier = (thickness) => {
    switch(thickness) {
      case '1/8':
        return 0.0117;
      case '5/32':
        return 0.0169;
      case '3/16':
        return 0.0174;
      case '1/4':
        return 0.0224;
      case '3/8':
        return 0.0332;
      case '1/2':
        return 0.0442;
      case '5/8':
        return 0.0537;
      case '3/4':
        return 0.0632;
      default:
        return 1;
  }
}

const get_item_weight = () => {
    const thickness = $( "input[name=select_thickness]:checked").val();
    const thickness_multiplier = get_weight_thickness_multiplier(thickness);
    const item_weight = (surface_area * thickness_multiplier).toFixed(2);

    return item_weight + ' lbs';
}

redirectToQuotationPage = () => {
    window.location.href = "/pages/quotation";
}

// Function to set dimension labels
function setDimensionLabels(label1, label2 = '') {
    $('#listOfDimensionValues206-text').html(`${label1} <span class="ml-10 mr-10">-</span> Choose:`);
    $('#listOfDimensionValues207-text').html(`${label2} <span class="ml-10 mr-10">-</span> Choose:`);
}

const get_selected_dimensions_values = () => {
    const first_val = $('#listOfDimensionValues206').val();
    const second_val = $('#listOfDimensionFractions_206').val();
    const third_val = $('#listOfDimensionValues207').val();
    const fourth_val = $('#listOfDimensionFractions_207').val();

    return [first_val, second_val, third_val, fourth_val]
}

const update_hole_price = () => {
    let holeText = '';

    if ( glassHoleEnabled === true ) {
        const hole = $( "input[name=select_hole]:checked").val();
        if(hole == "Center Hole (Umbrella Hole)"){
            $('.step4').val('10');
            var holee = $('#holesize').find(":selected").text();
        }else{
            $('.step4').val('0');
            var holee = '';
        }
      holeText = hole+ '['+ holee +'] ';
    }

    const thickness = $( "input[name=select_thickness]:checked").val();
    const glass = $( "input[name=select_thickness-1]:checked").val();

    $('.glass_thickness').text(thickness+'" ' + holeText + glass);
    $('.Selected_tickness').text(thickness+'" ' + holeText + glass);
}

$( document ).ready(function() {
    showFields('.rect_edge', '.for_rect');
    hideFields('.circle_edge', '.for_rounded');

    setDimensionLabels('Length (L)', 'Width (W)');

    showFields('.length-width');
    hideFields('.diamerter', '.length2_width', '.length3_width', '.edge', '.serface_leng_wid', '.length2_width_heigth', '.width2_height', '.edge_leng_wid', '.leng_width_edge2', '.radius', '.radiuscr', '.height_width_ww');

    const imag = '/cdn/shop/files/rectangle_a8fa4589-2357-41e2-af15-728cfd6d9b5b.png?v=1626760537';
    $('.seleted_imag').attr('src','https:'+imag);

    $('.selected_shape').text(selectedShape);
    $('.selected_shape').val(selectedShape);

    update_url("select-dimensions");

    $(".step-1-back").click(function() {
        $("#mob_tab_3").css("display", "none");
        $(".mob_tab3").css("display", "none");
        $("#mob_tab_2").css("display", "block");
        $(".mob_tab2").css("display", "block");
        $('[data-tab="tab-2"]').addClass('active-tabs');
        $('[data-tab="tab-3"]').removeClass('active-tabs');
        update_url("select-dimensions");
    });

    $('[data-tab="tab-3"]').click(function() {
        document.querySelectorAll('.base-price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $('[data-tab="tab-4"]').click(function() {
        document.querySelectorAll('.bp_thick_price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $('[data-tab="tab-5"]').click(function() {
        document.querySelectorAll('.base_n_thick_price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    //demesion click
    $( ".continue__tab-2" ).click(function() {
        $( "input[name=select_thickness]" ).each(function( index ) {
            $(this).prop('checked', false);

            if($(this).val() == "1/4"){
                $(this).prop('checked', true);
            }
        });

        if ( glassHoleEnabled === true ) {
          $( "input[name=select_hole]" ).each(function( index ) {
              $(this).prop('checked', false);
  
              if($(this).val() == "No Hole"){
                  $(this).prop('checked', true);
              }
          });
        }

        $('.step4').val(0);

        const [first_val, second_val, third_val, fourth_val] = get_selected_dimensions_values();

        $('.cwidth').text(`Length - ${first_val}" ${second_val}"`);
        $('.cheight').text(`Width - ${third_val}" ${fourth_val}"`);

        $('.desmino_mas').text('(L)'+first_val+'" '+second_val+'" X (W)'+third_val+'" '+fourth_val+'" ');

        $('.dim_length').val(first_val);
        $('.dim_frac_length').val(second_val);
        $('.dim_width').val(third_val);
        $('.dim_frac_width').val(fourth_val);

        var x = parseFloat(first_val) * parseFloat(third_val);  
        $('.total_inch_space').val(x);

        if(x <= 399){
            var adding_value = 0.17;
            var final_val = add_min_price;
        }else if(x >= 400){
            var adding_value = 0.153;
            var final_val = parseFloat(x) * adding_value;        
        }
        console.log( parseFloat(x)+'**'+ adding_value)

        $('.adding_value').val(adding_value);
        $('.step1').val(final_val);

        calulate_item_surface_area(first_val, third_val);
        update_base_price(first_val, third_val);
        update_polishing_price();

        var sun = get_initial_amount();

        $('.counter_value').each(function() {         
            sun += parseFloat($(this).val());
        });

        $('.total_price').val(sun);
        $('.price__ok').find('p').find('span').text('$ '+sun.toFixed(2) );

        $('.price_for_mobile strong').text('$ '+sun.toFixed(2));

        update_initial_amount();
        update_url("select-glass-type");

        document.querySelectorAll('.base-price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    // for glass_types input change
    $('input[name=glass_types]').change(function(){
        document.querySelectorAll('.base-price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $(".step-2-back").click(function() {
        $("#mob_tab_4").css("display", "none");
        $(".mob_tab4").css("display", "none");
        $("#mob_tab_3").css("display", "block");
        $(".mob_tab3").css("display", "block");
        $('[data-tab="tab-3"]').addClass('active-tabs');
        $('[data-tab="tab-4"]').removeClass('active-tabs');
        update_url("select-glass-type");
        document.querySelectorAll('.base-price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $( ".continue__tab-3" ).click(function() {
        $( "input[name=select_thickness]" ).each(function( index ) {
            $(this).prop('checked', false);

            if($(this).val() == "1/4"){
                $(this).prop('checked', true);
            }
        });

        if ( glassHoleEnabled === true ) {
          $( "input[name=select_hole]" ).each(function( index ) {
              $(this).prop('checked', false);
  
              if($(this).val() == "No Hole") {
                  $(this).prop('checked', true);
              }
          });
        }

        $('.step3').val('20');

        var value = $('input[name=glass_types]:checked').attr('data-price');      
        $('.selected_lens').text($('input[name=glass_types]:checked').val());
        var selectedGlassType = $('input[name=glass_types]:checked').val();  

        update_thickness_options(selectedGlassType);
        update_thickness_price();

        const glassTypePrice = getGlassTypePrice(selectedGlassType);
        $('.step_glass').val(glassTypePrice);

        var sun = get_initial_amount();
        $('.counter_value').each(function() {         
            sun += parseFloat($(this).val());
        });

        $('.total_price').val(sun);
        $('.price__ok').find('p').find('span').text('$ '+sun.toFixed(2) );
        $('.price_for_mobile strong').text('$ '+sun.toFixed(2));

        update_url("select-thickness-hole-strength");
        
        document.querySelectorAll('.bp_thick_price').forEach(function(el) {
            let priccc = calculate_price();
            console.log("Pricc", priccc);
            el.textContent = '$ ' + calculate_price();
        });
    });

    $( "#listOfDimensionValues206").change(function() {
        var val = $(this).val();
        var title = 'Rectangle';

        if(title == "Square" || title == "Semi Circle"){
            $('#listOfDimensionValues207 option[value='+val+']').attr('selected','selected');
        }
    });

    $( "#listOfDimensionValues207").change(function() {
        var val = $(this).val();
        var title = 'Rectangle';

        if(title == "Square" || title == "Semi Circle"){
            $('#listOfDimensionValues206 option[value='+val+']').attr('selected','selected');
        }
    });

    $('.glass-grid>ul>li.selection').click(function() {
        if($(".active-tabs-head").length>1){
            $('.mobile_tabs').addClass("active-tabs").siblings('mobile_tabs').removeClass("active-tabs");
        }
    });

    $('.glass-grid>ul>li.selection').click(function() {
        $('#num2').addClass('active-tabs');
        $('#num1, #num3, #num4, #num5, #num6').removeClass('active-tabs');
    });

    $('.add').click(function () {
        if ($(this).prev().val() < 999) {
            quantity_selected = parseInt($(this).prev().val()) + 1;
            $(this).prev().val(quantity_selected);

            update_order_summary();
        }
    });

    $('.sub').click(function () {
        if ($(this).next().val() > 1) {
            quantity_selected = parseInt($(this).next().val()) - 1;
            $(this).next().val(quantity_selected);

            update_order_summary();
        }
    });

    $('input[name=select_thickness]').click(function(){
        update_thickness_price();
        document.querySelectorAll('.bp_thick_price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $('input[name=select_thickness-1]').click(function(){
        var total_space = $('.total_inch_space').val();

        if(total_space > 0){
            if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass"){
                var final_value = total_space * parseFloat(0.0139);
                var get_val = '20';
            }else{
                var final_value = total_space * parseFloat(0.0139);
                var get_val = '0';
            }
            $('.step3').val(get_val);

            sun = get_initial_amount();
            $('.counter_value').each(function() {         
                sun += parseFloat($(this).val());
            });

            $('.total_price').val(sun);
            $('.price__ok').find('p').find('span').text('$ '+sun.toFixed(2));  
            $('.price_for_mobile strong').text('$ '+sun.toFixed(2));
        }
    });

    $('input[name=select_hole]').change(function(){
        var change = $('input[name=select_hole]:checked').val();

        if(change == "Center Hole (Umbrella Hole)"){
            $('.step4').val('10');
        }else{
            $('.step4').val('0');
        }

        calculate_final_amount();
        update_final_price_to_dom();
    });

    $(".step-3-back").click(function() {
        $("#mob_tab_5").css("display", "none");
        $(".mob_tab5").css("display", "none");
        $("#mob_tab_4").css("display", "block");
        $(".mob_tab4").css("display", "block");
        $('[data-tab="tab-4"]').addClass('active-tabs');
        $('[data-tab="tab-5"]').removeClass('active-tabs');
        update_url("select-thickness-hole-strength");
    });

    $( ".continue__tab-4" ).click(function() {
        const total_space = $('.total_inch_space').val();

        $( "input[name=select_edging]" ).each(function( index ) {
            $(this).prop('checked', false);

            if($(this).val() == "Flat Polished Edge"){
                $(this).prop('checked', true); 
            }
        });

        update_hole_price();

        if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass"){
            var final_value = total_space * parseFloat(0.0139);
            var get_val = '20';
        }
        else{
            var final_value = total_space * parseFloat(0.0139);
            var get_val = '0';
        }
        $('.step3').val(get_val);

        update_thickness_price();

        if(allowed_corner_shapes.includes(selectedShape)){
            $('#cornerFinishDiv, #summary-column-corner').show();
        }else{
            $('#cornerFinishDiv, #summary-column-corner').hide();
        }

        update_edging_corner_price();
        update_url("select-edging-corner-finish");
        
        document.querySelectorAll('.base_n_thick_price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
    });

    $('input[name=select_edging]').click(function(){
        var edge = $('input[name=select_edging]:checked').val();
        if( edge == 'Beveled Edge'){
            $('#bevealed_size').removeClass('d-none');
        }else{
            $('#bevealed_size').addClass('d-none');
        }
        update_edging_corner_price();
    });

    $('input[name=corner_finish]').change(function(){
        update_edging_corner_price();
    });

    function update_edging_corner_price(){
        update_polishing_price();
        var edging_price = polishing_price;
        var corner_price = parseFloat($('input[name=corner_finish]:checked').attr('data-type'));
        var price = edging_price + corner_price

        $('.step5').val(price);
        document.querySelectorAll('.base_n_thick_price').forEach(function(el) {
            el.textContent = '$ ' + calculate_price();
        });
        update_order_summary();
    }

    $( ".continue__tab-5" ).click(function() {
        var edging_price = polishing_price;
        var corner_price = parseFloat($('input[name=corner_finish]:checked').attr('data-type'));
        var price = edging_price + corner_price;

        $('.step5').val(price);

        let title = $('input[name=select_edging]:checked').val();
        if( title == 'Beveled Edge' ){
            title = $('select[name=bevealed_edge_size]').val() + ' ' + title;
        }
        $('.selected_edge').text(title);

        update_order_summary();
        update_url("order-summary");
    });

    const get_properties = function () {
        const properties = {
            'Shape': 'Rectangle',
            'Dimensions': $('.glass_demesion').text(),
            'Glass Type': $('.glass_type').text(),
            'Thickness': $('.glass_thickness').text(),
            'Edge': $('.glass_edeging').text(),
        };

        if(allowed_corner_shapes.includes(selectedShape)){
            properties['Corner Finish'] = $('.selected_corner').text();
        }

        // properties['Glass Recut Protection'] = $('input[name=glass_recut_protection]:checked').val();

        const item_weight = get_item_weight();
        properties['Weight'] = item_weight;
        return properties;
    }

    $('.buy_now_shipping').click(function () {
        $(this).addClass('loading');

        const title = $('input[name="title"]').val();
        const properties = get_properties();

        const data = {
            title: title,
            price: final_amount,
            properties: properties
        };

        const params = {
            type: 'POST',
            url: createShopifyProductUrl,
            data: data,
            dataType: "json"
        };

        $.ajax(params)
        .done(
            function(response) {
                var id = response.product.variants[0].id;
                var product_id = response.product.id;

                //Product created using shopify admin api.. add to cart it now.
                addToCart(id, properties);
            }.bind(this)
        )
        .fail(
            function(response) {
                console.log(response);
            }.bind(this)
        );
    });
});

function scroll_to_top() {
    $('html, body').animate({
        scrollTop: $('.custom-page-container').offset().top
    }, 1000);
}

var update_url = function( title ) {
    var obj = { Title: title, Url: '#'+ title };
    history.pushState(obj, obj.Title, obj.Url);

    showHideTestimonials(title);
    //toggleBottomSections(title);
}

// const toggleBottomSections = function (title) {
//     const selectors = $('#shopify-section-thickness-chart, #shopify-section-glass-edges, #shopify-section-glass-finishing');

//     if(title === 'select-thickness-hole-strength' || title === 'select-edging-corner-finish') {
//         selectors.css('display', 'block');
//     } else {
//         selectors.css('display', 'none');
//     }
// }

window.onhashchange = function() {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    navigate_to_step( hash, false );
}

$(document).on('click', '.active-tabs-head, .mobile_tabs.active-tabs', function(){
    var step = $(this).data('step');
    update_url(step);
    navigate_to_step(step);
});

const navigate_to_step = (step, update_hash = true) => {
    if( step == '' ){
        step = 'select-dimensions';
    }

    if( update_hash ){
        update_url( step );
    }

    $('.tab--content').hide();
    $(".tab-containes-content").find(".tab--content[data-step='" + step + "']").show();

    $('.steps-grid ul li, .mobile_tabs').removeClass('active-tabs');
    $("[data-step='" + step + "']").addClass('active-tabs');

    scroll_to_top();
}

/*** Get Price for the glass type ***/
const getGlassTypePrice = (selectedGlass) => {
    const defaultPercentageIncrease = 50;
    const glassType = (selectedGlass || "").toLowerCase();

    // Define the percentage increases for each glass type
    const glassPriceIncreases = {
        "clear glass": 0,
        "ultra clear": ultra_clear_glass_price,
        "gray glass": gray_glass_price,
        "tint bronze glass": tint_bronze_glass_price,
        "frosted (etch) glass": frosted_glass_price,
        "black glass": black_glass_price,
    };

    // Fetch the percentage increase; default to 50 for unrecognized glass types
    const percentageIncrease = glassPriceIncreases[glassType] ?? defaultPercentageIncrease;

    // Calculate and return the final price
    return calculateColoredGlassPrice(percentageIncrease);
};

function calculateColoredGlassPrice(percentageIncrease)
{
    if(percentageIncrease === 0) {
      return 0;
    }
    calculate_final_amount();

 // alert('Total From original function: ' +  final_amount.toString());
    //alert('Percentage Increase: ' +  percentageIncrease.toString());


    return final_amount * (percentageIncrease / 100);
}

$(document).ready(function(){

    $('.select_demis').click(function() {
        navigate_to_step('select-dimensions');
    });

    $('.select_lens').click(function() {
        navigate_to_step('select-glass-type');
    });

    $('.select_thickness').click(function() {
        navigate_to_step('select-thickness-hole-strength');
    });

    $('.select_edge').click(function() {
        navigate_to_step('select-edging-corner-finish');
    });

    $('#num1, #num2, #num3 #num6, .continue__tab-5.span_btn').click(function(){
        $('.mobile_bottom_mirror').removeClass('active');
    });

    $('.continue__tab-3.span_btn, .continue__tab-4.span_btn, .active-tabs-head').click(function(){
        $('.mobile_bottom_mirror').addClass('active');
    });

    $("#num4.active-tabs-head, #num5.active-tabs-head").click(function(){
        $('.mobile_bottom_mirror').addClass('active');
    });

    $(".active-tabs ~ .mobile_tabs").click(function(){
        $('.mobile_bottom_mirror').addClass('active');
    });

    $(".active-tabs ~ .mob_tab2.mobile_tabs, .active-tabs ~ .mob_tab3.mobile_tabs, .active-tabs ~ .mob_tab6.mobile_tabs").click(function(){
        $('.mobile_bottom_mirror').removeClass('active');
    });

    $('input[name=corner_finish], .corner-size, .corners-checkbox').change(function(){
        var ths = $(this);
        $('.cornersize').hide();

        let cornerType = $('input[name="corner_finish"]:checked').val();
        let cornerFinish = '';

        if(cornerType!= 'None'){
            var parent = ths.closest('li');
            parent.find('.cornersize').show();

            const cornerSize = parent.find('.corner-size').val();
            const selectedCorners = getSelectedCorners(parent);

            cornerFinish = `${cornerSize}" ${cornerType} With ${selectedCorners}`;
        }else{
            cornerFinish = cornerType;
        }

        $('#summary-column-corner .selected_corner').text(cornerFinish)
    });

    const getSelectedCorners = (object) => {
      let selectedCorners = new Array();
      const cornerElements = object.find('.corners-checkbox:checked');

      cornerElements.each(function(){
          selectedCorners.push($(this).val());
      });

      const text = selectedCorners.join(', ');
      return text;
    }

    $('input[name="glass_recut_protection"]').on('change', function() {
      update_order_summary();
    });
  
    var hover_img_selector = $('#mob_tab_3 .tab--grid-ul li .hover_img');
    function hover_image_default_position(){
        var right = screen.width <= 749 ? '0' : '-100px';
        hover_img_selector.css({ position: 'absolute', top: 0, right: right });
    }

    function adjust_hover_image(){
        var selector = $('#mob_tab_3 .tab--grid-ul li .hover_img');
        if( screen.width <= 749  ){
            var target = $('#mob_tab_3 .tab--grid-ul');
            var offset_top = target.offset().top;
            selector.css({ position: 'fixed', right: '20px' });
            selector.offset({top:offset_top + 30});
        }else{
            hover_image_default_position();
        }
    }

    $(window).scroll(function(){
        adjust_hover_image();
    });
    $(window).resize(function(){
        adjust_hover_image();
    });

    adjust_hover_image();

    $('.cg__step3 .tab--grid-ul li').click(function(){
        const image = $(this).data('image');
        $('#glassImages .select_glass_img').attr('src', image);
    });
});